<template>
  <div id="header">
    <v-toolbar
      flat
      app
      color="white"
      height="56px"
      :class="{ [$style.hiddenHeader]: isHeaderHidden }"
    >
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <a :class="$style.noLineLink" v-bind:href="siteUrl">
        <img :class="$style.clipLogoIcon" :src="clipLogo" />
        <span
          :class="[
            {
              caption: $vuetify.breakpoint.xsOnly,
              'body-2': $vuetify.breakpoint.smAndUp
            },
            $style.clipLogoText
          ]"
        >
          {{ lang.name }}
        </span>
      </a>

      <v-spacer></v-spacer>

      <v-btn
        v-if="isLoggedIn && !myContentsButtonHide"
        color="success"
        class="hidden-sm-and-down"
        round
        :style="{ 'text-transform': 'none' }"
        @click="createLink('/my-contents')"
      >
        {{ lang.my_contents_button }}
      </v-btn>

      <v-toolbar-items v-if="isLoggedIn">
        <v-menu transition="slide-x-reverse-transition" offset-y left attach>
          <v-btn
            :class="{ 'px-0': $vuetify.breakpoint.xsOnly }"
            v-bind="{ icon: $vuetify.breakpoint.xsOnly }"
            flat
            slot="activator"
          >
            <v-badge
              v-bind="{
                color: hasNotificationImportant ? '#FF5050' : '#00A000'
              }"
              v-model="showHeaderBadge"
              overlap
            >
              <span slot="badge"></span>
              <vc-share-avatar-image :size="35" :src="displayUserProfileImage">
              </vc-share-avatar-image>
            </v-badge>
            <v-icon large class="hidden-sm-and-down">arrow_drop_down</v-icon>
          </v-btn>

          <v-list>
            <v-list-tile @click="createLink('/upload-contents-select')">
              <v-list-tile-title>{{ lang.upload_contents }}</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="createLink('/my-contents')">
              <v-list-tile-title>{{ lang.my_contents }}</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="openToPage(starredUrl)">
              <v-list-tile-title>{{ lang.starred }}</v-list-tile-title>
            </v-list-tile>
            <v-divider></v-divider>
            <v-list-tile
              v-if="!isIce"
              @click="openToPage(accountEditUrl, '_self')"
            >
              <v-list-tile-title>{{ lang.account_profile }}</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="linkToPage(notificationUrl)">
              <v-list-tile-title>
                {{ lang.account_notification }}
                <v-icon
                  v-show="hasNotification"
                  class="pl-2 pb-1"
                  :class="$style.notificationIcon"
                  small
                  :style="{
                    color: hasMenuNotificationImportant ? '#FF5050' : '#00A000'
                  }"
                >
                  fas fa-circle
                </v-icon>
              </v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="linkToPage(directMessageUrl)">
              <v-list-tile-title>
                {{ lang.account_direct_message }}
                <v-icon
                  v-show="hasDirectMessage"
                  class="pl-2 pb-1"
                  :class="$style.notificationIcon"
                  small
                  color="#FF5050"
                >
                  fas fa-circle
                </v-icon>
              </v-list-tile-title>
            </v-list-tile>
            <template v-if="!isIce">
              <v-divider></v-divider>
              <v-list-tile @click="createLink('/logout')">
                <v-list-tile-title>{{ lang.account_logout }}</v-list-tile-title>
              </v-list-tile>
            </template>
          </v-list>
        </v-menu>
      </v-toolbar-items>

      <v-toolbar-items v-else-if="!isIce">
        <v-btn
          :style="{ 'text-transform': 'none' }"
          class="hidden-sm-and-down"
          v-bind:href="logInUrl"
          flat
        >
          <v-icon>person</v-icon>
          <span>{{ lang.account_login }}</span>
        </v-btn>
        <v-btn
          :style="{ 'text-transform': 'none' }"
          class="hidden-sm-and-down"
          v-bind:href="accountRegistrationUrl"
          flat
        >
          <v-icon>person_add</v-icon>
          <span>{{ lang.account_registration }}</span>
        </v-btn>

        <v-menu
          class="hidden-md-and-up"
          transition="slide-x-reverse-transition"
          offset-y
          left
          attach
        >
          <v-btn
            :class="{ 'mx-0': $vuetify.breakpoint.xsOnly }"
            slot="activator"
            icon
          >
            <v-icon>exit_to_app</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile @click="linkToPage(logInUrl)">
              <v-list-tile-title>{{ lang.account_login }}</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="linkToPage(accountRegistrationUrl)">
              <v-list-tile-title>
                {{ lang.account_registration }}
              </v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar-items>
    </v-toolbar>

    <v-navigation-drawer v-model="drawer" app temporary>
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>

      <v-divider></v-divider>

      <v-list dense class="pt-0">
        <v-list-tile @click="linkToPage(siteUrl)">
          <v-list-tile-title>{{ lang.service_home }}</v-list-tile-title>
        </v-list-tile>
        <v-list-tile @click="createLink('/help')">
          <v-list-tile-title>{{ lang.service_help }}</v-list-tile-title>
        </v-list-tile>
        <v-list-tile @click="linkToPage(termsUrl)">
          <v-list-tile-title>{{ lang.service_terms }}</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import fetchJsonp from "fetch-jsonp";
import log from "loglevel";
import ice from "../../../lib/ice";

const HEADER_HEIGHT = 56;

export default {
  name: "vc-share-appbar",
  props: {
    isLoggedIn: {
      type: Number,
      required: true,
      default: 0
    },
    isIce: {
      type: Boolean,
      default: false
    },
    logInUrl: {
      type: String,
      default: ""
    },
    accountRegistrationUrl: {
      type: String,
      default: ""
    },
    locale: {
      type: String,
      default: "ja-jp"
    },
    siteUrl: {
      type: String,
      default: ""
    },
    profileUrl: {
      type: String,
      default: ""
    },
    assetsUrl: {
      type: String,
      default: ""
    },
    askUrl: {
      type: String,
      default: ""
    },
    tipsUrl: {
      type: String,
      default: ""
    },
    shareUrl: {
      type: String,
      default: ""
    },
    autoHideHeader: {
      type: Boolean,
      default: false
    },
    lang: {
      type: Object,
      default: () => {
        return {
          name: "CLIP STUDIO SHARE",
          service_home: "ホーム",
          service_help: "ヘルプ",
          service_support: "サポート",
          service_terms: "利用規約など",
          site_prof_desc: "自己紹介/アクティビティ",
          site_assets_desc: "素材をさがす",
          site_ask_desc: "質問＆回答",
          site_tips_desc: "学ぶ、教える",
          site_share_desc: "作品を見せる",
          upload_contents: "作品投稿",
          my_contents: "投稿一覧",
          starred: "お気に入りの作品",
          account_profile: "アカウント",
          account_notification: "通知",
          account_direct_message: "ダイレクトメッセージ",
          account_login: "ログイン",
          account_logout: "ログアウト",
          account_registration: "アカウント登録",
          my_contents_button: "公開した作品一覧"
        };
      }
    },
    myContentsButtonHide: {
      type: Boolean,
      default: false
    },
    dev: {
      type: Object,
      default: () => ({
        site_prof_title: "PROFILE",
        site_assets_title: "ASSETS",
        site_ask_title: "ASK",
        site_tips_title: "TIPS",
        site_share_title: "SHARE"
      })
    },
    profileBaseUrl: {
      type: String,
      default: ""
    },
    accountBaseUrl: {
      type: String,
      default: ""
    },
    subToken: {
      type: String,
      default: ""
    },
    userProfileImage: {
      type: String,
      default: ""
    },
    starredUrl: {
      type: String,
      default: ""
    },
    accountEditUrl: {
      type: String,
      default: ""
    },
    notificationUrl: {
      type: String,
      default: ""
    },
    directMessageUrl: {
      type: String,
      default: ""
    },
    termsUrl: {
      type: String,
      default: ""
    }
  },
  data: function() {
    return {
      drawer: false,
      hasNotification: false,
      hasDirectMessage: false,
      hasMenuNotificationImportant: false,
      hasNotificationImportant: false,
      showHeaderBadge: false,
      clipLogo: require("./assets/logo_clip.png"),
      displayUserProfileImage: this.userProfileImage,
      defaultUserPictureUrl: require("./assets/ico_noimage.gif"),
      isHeaderHidden: false,
      scrollOffset: 0,
      reloaded: false
    };
  },
  methods: {
    createLink: function(url) {
      location.href = "/" + this.locale + url;
    },
    linkToPage: function(url) {
      location.href = url;
    },
    openToPage: function(url, target = "_blank") {
      if (ice.isIce()) {
        ice.openUrl(url, true);
      } else {
        open(url, target);
      }
    },
    altSrc: function() {
      this.displayUserProfileImage = this.defaultUserPictureUrl;
    },
    showHeaderOnScroll: function() {
      if (!this.isHeaderHidden) {
        return;
      }
      let thisObject = this;
      window.requestAnimationFrame(function() {
        let position = window.scrollY;
        if (window.scrollY > HEADER_HEIGHT) {
          document.getElementById("header").style.marginBottom = null;
          thisObject.isHeaderHidden = false;
          window.removeEventListener(
            "touchmove",
            thisObject.showHeaderOnScroll
          );
        }
        thisObject.scrollOffset = position;
      });
    },
    switchHeaderAppearance: function() {
      if (!this.isHeaderHidden) {
        return;
      }
      if (this.$vuetify.breakpoint.xsOnly) {
        document.getElementById("header").style.marginBottom =
          "-" + HEADER_HEIGHT + "px";
        this.isHeaderHidden = true;
        window.addEventListener("touchmove", this.showHeaderOnScroll, {
          passive: false
        });
      } else {
        document.getElementById("header").style.marginBottom = null;
        this.isHeaderHidden = false;
        window.removeEventListener("touchmove", this.showHeaderOnScroll);
      }
    }
  },
  mounted: function() {
    let thisObject = this;
    if (this.autoHideHeader) {
      this.isHeaderHidden = true;
      this.switchHeaderAppearance();
    }
    if (this.subToken === "") {
      return;
    }
    fetchJsonp(
      this.profileBaseUrl +
        "/notification-update/has-update?token=" +
        encodeURI(this.subToken),
      {
        jsonpCallbackFunction: "callback"
      }
    )
      .then(function(response) {
        return response.json();
      })
      .then(function(json) {
        thisObject.hasNotification = json.response_data.has_notification;
        thisObject.hasDirectMessage = json.response_data.has_direct_message;
        thisObject.hasNotificationImportant = !!(
          json.response_data.has_notification_important ||
          thisObject.hasDirectMessage
        );
        thisObject.hasMenuNotificationImportant =
          json.response_data.has_notification_important;
        thisObject.showHeaderBadge = !!(
          thisObject.hasNotification || thisObject.hasDirectMessage
        );
      });

    if (!ice.isIce() && this.isLoggedIn) {
      fetch(this.accountBaseUrl + "/webapi/active-account", {
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=utf-8"
        },
        mode: "cors",
        credentials: "include"
      })
        .then(async response => {
          // 200じゃない場合はスロー
          if (!response.ok) {
            throw response;
          }
        })
        .catch(function(ex) {
          log.error("error response:", ex);
        });
    }
  },
  watch: {
    "$vuetify.breakpoint": function() {
      if (this.autoHideHeader) {
        this.switchHeaderAppearance();
      }
    },
    deep: true
  },
  destroyed: function() {
    window.removeEventListener("touchmove", this.showHeaderOnScroll, {
      passive: false
    });
  }
};
</script>

<style module>
.noLineLink {
  text-decoration: none;
  color: #000;
}

.notificationIcon {
  vertical-align: middle;
}

.clipLogoIcon {
  width: 20px;
  vertical-align: middle;
}

.clipLogoText {
  vertical-align: middle;
}

.hiddenHeader {
  transform: translateY(-100%) !important;
}
</style>
